// eslint-disable

import { useQuery } from '@tanstack/react-query'
import { Pagination } from 'src/components/datagrid'
import { ICardItem } from 'src/types/card'
import axiosInstance from 'src/utils/axios'

type Cards = {
  data: ICardItem[]
  page: number
  perPage: number
  totalPages: number
  total: number
  // Saldo total de todos os cartões que batem no filtro (não só a página).
  totalBalance: number
}

async function fetchUser(pagination: Pagination, filters: any): Promise<Cards> {
  const res = await axiosInstance.get('/card', {
    params: {
      ...filters,
      ...pagination,
    },
  })
  return res.data
}

function useCard(pagination: Pagination, filters?: any) {
  return useQuery(['card', pagination, filters], () => fetchUser(pagination, filters), {
    keepPreviousData: true,
    staleTime: 5000,
  })
}

// Busca todos os cartões que batem no filtro atual (para exportação),
// ignorando a paginação da tela.
export async function fetchAllCards(filters?: any): Promise<ICardItem[]> {
  const res = await axiosInstance.get('/card', {
    params: {
      ...filters,
      page: 1,
      perPage: 100000,
      sort: 'createdAt',
      order: -1,
    },
  })
  return res.data?.data || []
}

export default useCard
